import { Box, Typography } from '@material-ui/core';
import type { LaunchPadData, PublicCollectionData } from '@mogul/api-client';
import React from 'react';

import { ReactComponent as DiscordIcon } from '../../common/svg/launchpad/icon-discord.svg';
import { ReactComponent as TwitterIcon } from '../../common/svg/launchpad/icon-twitter.svg';
import { CollectionAnalyticsCard } from '../../components/collection/collection-analytics-card/CollectionAnalyticsCard.component';
import { ReadMore } from '../../components/common/readMore/ReadMore.component';
import { Button as CoreButton } from '../../components/core/button/Button';
import styles from './CollectionInner.module.css';

export interface Props {
  collection: PublicCollectionData | undefined | null;
  launchPad?: LaunchPadData | null;
  supply?: number;
  owners?: number;
  nftContractAddress?: string;
  goToLandingPage?: () => void;
}

export const CollectionInner: React.FC<Props> = props => {
  const {
    launchPad,
    collection,
    supply = 0,
    owners = 0,
    nftContractAddress,
    goToLandingPage,
  } = props;

  return (
    // Call container
    <div className="flex flex-col text-center justify-between items-center">
      {collection?.bannerImageUrl && (
        <img
          src={collection.bannerImageUrl}
          alt="img"
          className={styles.bannerImage}
        />
      )}
      <div className="w-full lg:flex relative justify-center">
        <img
          src={collection?.logoImageUrl ?? ''}
          alt="img"
          className={`${styles.posterImage} mt-5 rounded-lg object-cover`}
        />
        {launchPad ? (
          <div
            className={
              'w-full flex items-center ' + styles.collectionLinkButton
            }
          >
            <CoreButton
              onClick={goToLandingPage}
              className={styles.collectionButton}
              label={'Learn More'}
            />
            <div className={'flex ' + styles.icons}>
              {launchPad.communityInfo ? (
                JSON.parse(JSON.stringify(launchPad.communityInfo)).discord ? (
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href={
                      JSON.parse(JSON.stringify(launchPad.communityInfo))
                        .discord
                    }
                  >
                    <div
                      className={
                        'flex justify-center items-center ' + styles.socialIcon
                      }
                    >
                      <DiscordIcon className={`${styles.discord}`} />
                    </div>
                  </a>
                ) : (
                  <></>
                )
              ) : (
                <></>
              )}

              {launchPad.communityInfo ? (
                JSON.parse(JSON.stringify(launchPad.communityInfo)).twitter ? (
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href={
                      JSON.parse(JSON.stringify(launchPad.communityInfo))
                        .twitter
                    }
                  >
                    <div
                      className={
                        'flex justify-center items-center ' + styles.socialIcon
                      }
                    >
                      <TwitterIcon className={styles.twitter} />
                    </div>
                  </a>
                ) : (
                  <></>
                )
              ) : (
                <></>
              )}
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
      <div
        className={
          'fontVanguard font-semibold text-primary xl:text-7xl md:text-6xl text-4xl mt-3 mb-1'
        }
      >
        {collection ? collection.name : 'Collection'}
      </div>
      <div
        className={`${styles.contractColor} font-medium text-sm md:text-lg leading-5 mt-1 mb-3 ml-4`}
      >
        {collection ? collection.contractAddress : nftContractAddress}
      </div>
      <Box
        className={`${styles.cardBackground} w-2/3 rounded-lg mx-5 sm:mx-0 md:p-5 lg:my-5 flex flex-wrap justify-center place-items-center p-3 my-1 mb-0 pb-0 text-center`}
      >
        <ReadMore>
          <Typography>{collection ? collection.description : ''}</Typography>
        </ReadMore>
      </Box>
      <CollectionAnalyticsCard supply={supply} owners={owners} />
    </div>
  );
};
